import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx("path", { d: "M5 30h30v-3.333H5zm0-8.333h30v-3.334H5zM5 10v3.333h30V10z", fill: "currentColor" }) });
export {
  s as B
};
